import React, { useState } from 'react';
import DetailLayout from '../DetailLayout';
import Tabs, { TabsEnum } from '../Tabs';
import './index.less';
import Progress from 'containers/OutBidding/ProjectDetail/Show/Progress';

const DetailLayoutWithTabs = (props: any) => {
  const { children, ...reset } = props;

  const [tab, setTab] = useState(TabsEnum.Process);

  const handleChangeTab = (v: TabsEnum) => {
    setTab(v);
  };

  const { detail = {} } = reset;

  return (
    <DetailLayout {...reset}>
      <Tabs onChange={handleChangeTab} />
      <div style={{ display: tab === TabsEnum.Process ? 'block' : 'none' }}>
        {children}
      </div>
      {tab === TabsEnum.Progress && (
        <div style={{ padding: 20 }}>
          <Progress projectId={detail.id} prefixCls="sm-project-detail-show" />
        </div>
      )}
    </DetailLayout>
  );
};

export default DetailLayoutWithTabs;
